<template>
  <v-container>
    <div class="home mt-12">
        <div class="text-center mt-2 ">
            <v-btn 
            class="text-center ma-3"        
            color="primary"        
            @click="addNotification()"
            >
            Add Notification
            </v-btn>
        </div>
        <v-dialog v-model="dialog" persistent max-width="600px" min-width="360px">
            <div>
            <v-card class="px-4">
              <v-card-text>
                <v-form ref="registerForm" v-model="valid" lazy-validation>
                  <v-row>
                    <v-col cols="12" >
                      <!-- <v-text-field
                        v-model="title"
                        :rules="[rules.required]"
                        label=""
                        maxlength="20"
                        required
                      >-->
                      <v-text-field
                        v-model="title"
                         clearable
                        label="Notification Title"
                        maxlength="25"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <!-- <v-text-field
                        v-model="Message"
                        :rules="[rules.required]"
                        label="Last Name"
                        maxlength="20"
                        required
                      ></v-text-field> -->
                      <v-textarea
                        v-model="message"
                        clearable
                        clear-icon="mdi-close-circle"
                        label="Notification Message"
                        value="This is clearable text."
                       ></v-textarea>
                    </v-col>                    
                    <v-col cols="12">
                      <!-- <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                      >-->
                      <v-text-field
                      v-model="srclink"
                      label="Link"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        :items="companies"
                        solo
                        v-model="selectedcompany"
                        label="Company"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <!-- <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, rules.min]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Password"
                        hint="At least 8 characters"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field> -->
                    </v-col>
                    <v-col cols="12">
                      <!-- <v-text-field
                        block
                        v-model="verify"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, passwordMatch]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Confirm Password"
                        counter
                        @click:append="show1 = !show1"
                      ></v-text-field> -->
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex ml-auto" cols="12" sm="3" xsm="12">
                      <!-- <v-btn
                        x-large
                        block
                        :disabled="!valid || loading"
                        :loading="loading"
                        color="primary"
                        @click="onSignup"
                        > -->
                       <v-btn
                        
                        color="primary"
                       >Add</v-btn>
                       <v-spacer></v-spacer>
                       <v-btn
                        
                        color="primary"
                       @click = "closeaddNotification"
                       >Cancel</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
            </div>
        </v-dialog>
      All Notifications List:
      <v-flex xs12 sm6 offset-sm3>
        <v-card
          class="d-flex pa-2 mb-3"
          color="#26c6da"
          dark
          max-width=""
          width="100%"
          justify="center"
          v-for="notificationItem in allNotifications"
          :key="notificationItem.uid"
        >
          <div class="d-inline-flex pa-2">{{ notificationItem }}</div>
        </v-card>
      </v-flex>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
// import Notification from "@/components/Notification";
// import firebase from "@firebase/app";
// import 'firebase/storage';

export default {
  name: "Home",
  components: {
    // Notification,
  },
  data() {
    return {    
        alert: false,
        dialog: false, 
        companies: ['All','Skymat', 'Triton'],
        selectedcompany: "",
        valid: true,
        msgdialog: false,
        title: "",
        message: "",
        srclink: "",
        isActive: "",
        groupNo: "",
        
        card_data: [
            {
            name: "Appointments",
            desc: "appointments today (0)",
            number: 8,
            icon: "",
            },
            { name: "BRVARs", 
            desc: "BRVARs pending (0)",
            number: 16, icon: "" },
            {
            name: "Blocked",
            desc: "blocked customers (0)",
            number: 55,
            icon: "",
            },
            {
            name: "Lead",
            desc: "New Lead",
            number: 55,
            icon: "",
            },        
        ],
    };
  },
  computed: {
    usersperson() {
      if (this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO) {
        return this.$store.getters.factsuser.USER_DEFAULT_SMAN_DOCNO;
      } else {
        return "";
      }
    },
    allNotifications(){
       return this.$store.getters.allNotifications
    }
  },
  methods: {
    // thisNotification(item){
    //   this.$store.dispatch("thisNotification", item)
    // },
    addNotification(){
        this.dialog = true
    },
    closeaddNotification(){
        this.dialog = false
    }
    // showthisNotification() {
    //   this.$emit("showthisNotification");
    // },
  },
  mounted() {
    this.notifications;
  },
  created(){
    this.$store.dispatch("getSalesPersons", { smandocno: this.usersperson })
    this.$store.dispatch("getallNotifications")
  }
  

};
</script>

